import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, ArrowRight } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
const destinations = [{
  id: 1,
  name: 'Nepal',
  description: 'Home to Everest and ancient temples',
  image: 'https://images.unsplash.com/photo-1544735716-392fe2489ffa?q=80&w=2071&auto=format&fit=crop',
  treks: '25+ Treks',
  link: '#destination-nepal'
}, {
  id: 2,
  name: 'Tibet',
  description: 'Roof of the world, spiritual heartland',
  image: 'https://images.unsplash.com/photo-1526716173434-a1b560f2065d?q=80&w=2070&auto=format&fit=crop',
  treks: '12+ Treks',
  link: '#'
}, {
  id: 3,
  name: 'Bhutan',
  description: 'Land of the Thunder Dragon',
  image: 'https://images.unsplash.com/photo-1578565697042-45e396d36e3c?q=80&w=2070&auto=format&fit=crop',
  treks: '8+ Treks',
  link: '#'
}];
export function DestinationsSection() {
  return <section className="py-20 bg-white" data-id="element-94">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-95">
        <SectionHeading title="Explore Destinations" subtitle="Discover the majestic Himalayan regions we specialize in." data-id="element-96" />

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-97">
          {destinations.map((destination, index) => <motion.a key={destination.id} href={destination.link} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="group relative h-96 rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 cursor-pointer" data-id="element-98">
              <div className="absolute inset-0" data-id="element-99">
                <img src={destination.image} alt={destination.name} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-100" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent" data-id="element-101" />
              </div>

              <div className="absolute bottom-0 left-0 p-6 w-full" data-id="element-102">
                <div className="flex items-center gap-2 text-[#06B6D4] mb-2" data-id="element-103">
                  <MapPin size={16} data-id="element-104" />
                  <span className="text-sm font-medium" data-id="element-105">
                    {destination.treks}
                  </span>
                </div>
                <h3 className="text-3xl font-bold text-white mb-2 group-hover:text-[#06B6D4] transition-colors" data-id="element-106">
                  {destination.name}
                </h3>
                <p className="text-gray-200 mb-4" data-id="element-107">{destination.description}</p>
                <span className="inline-flex items-center gap-2 text-white font-medium group-hover:gap-3 transition-all" data-id="element-108">
                  Explore Destination <ArrowRight size={18} data-id="element-109" />
                </span>
              </div>
            </motion.a>)}
        </div>
      </div>
    </section>;
}